import styled from 'styled-components'

export const ManageMyBookingWingieHeading = styled.h2`
  color: #131717;
  font-size: 24px;
  font-weight: 700;
  line-height: 33px;
  margin: 60px 0 16.5px 0;
  @media screen and (max-width: 962px) {
    margin: 32px 0 16.5px 0;
  }
`

export const ManageMyBookingRow = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
  flex-direction: ${(props) => (props.isMobile ? `column;` : `row;`)};
`

export const ManageMyBookingCol = styled.div`
  display: flex;
  background-color: #ffffff;
  gap: 16px;
  flex-grow: 1;
  flex: 1;
  border: 1px solid #d7dddb;
  border-radius: 8px;
  box-shadow: 0px 5px 22px 4px transparent;
  transition-duration: 0.2s;
  &:hover {
    box-shadow: 0px 5px 22px 4px #0000001f;
  }
`

export const ManageMyBookingWingieCardContainer = styled.div<{ isMobile: boolean }>`
  display: flex;
  /* flex-direction: ${(props) => (props.isMobile ? 'column' : 'row')}; */

  /* @media screen and (min-width: 962px) {
    & > div:nth-child(2) {
      margin: 0 14px;
    }
  } */

  @media screen and (max-width: 962px) {
    flex-wrap: wrap;
  }
`

export const ManageMyBookingWingieCard = styled.div<any>`
  display: flex;
  width: ${(props) => (props.isMobile ? 'auto' : '100%')};
  flex-direction: ${(props) => props.order};
  justify-content: flex-start;
  align-items: center;
  /* min-height: 124px; */
  background-color: #ffffff;
  padding: 16px 16px 16px 24px;
  gap: 24px;
  border-radius: 8px;
  /* margin-right: ${(props) => !props.isMobile && '20px'}; */
  align-items: flex-start;
`

export const Image = styled.div`
  height: auto;
  width: auto;
  border-radius: 50%;
`
export const ManageMyBookingWingieCardHeading = styled.div`
  color: #131717;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 21px;
  padding-bottom: 4px;
  padding-top: 2px;
  width: 23ch;
`
export const ManageMyBookingWingieCardSubheading = styled.div`
  color: #131717;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 21px;
`

export const DialogInputContainer = styled.div`
  flex-direction: column;
  display: flex;
  gap: 16px;
  margin-top: 16px;
`

export const DialogTabsWrapper = styled.div`
  margin-top: 8px;

  [role='tablist'] {
    margin-bottom: 0;
  }

  /* Form tab panellerinin dışında; default-panels padding boşluk yaratmasın */
  [class*='default-panels'],
  [class*='tabPanels'] {
    padding: 0 !important;
    background: transparent !important;
    min-height: 0 !important;
  }

  [role='tabpanel'] {
    display: none;
  }
`

export const ManageMyBookingWingieCardElement = styled.div`
  cursor: ${(props) => (props.cursor ? props.cursor : 'default')};
`
